import { render, staticRenderFns } from "./VIPWelfare.vue?vue&type=template&id=3f57243e&scoped=true&"
import script from "./VIPWelfare.vue?vue&type=script&lang=js&"
export * from "./VIPWelfare.vue?vue&type=script&lang=js&"
import style0 from "./VIPWelfare.vue?vue&type=style&index=0&id=3f57243e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f57243e",
  null
  
)

export default component.exports